import { find } from "@kluntje/js-utils/lib/dom-helpers";
import { WECNavigation } from "Components/wec-m-navigation/wec-m-navigation";

class NavigationService {
  private navigation: WECNavigation | null = null;

  constructor() {
    this.navigation = find<WECNavigation>(document.body, this.navigationId);
  }

  get navigationId() {
    return "#wec-navigation";
  }

  openNavigation() {
    this.navigation?.open();
  }

  closeNavigation() {
    this.navigation?.close();
  }
}

export default new NavigationService();
